// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_26Vdr","root":"_1Ql6S","modal":"TKBYt","continue":"_3UjSR","close":"_25dIu"};